<!-- LOADING -->
<app-loading [hidden]="!loading"></app-loading>

<!-- CONTEÚDO -->
<ng-container *ngIf="viewModules$ | async as vm">
<div *ngIf="!loading" class="flex flex-col">

    <!-- HEADER -->
    <div class="bg-white rounded-lg border border-gray-200 p-4 mb-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div class="flex flex-col">
            <h1 class="text-xl font-semibold text-westetics-neutral-950">
                {{ standalone ? 'Gerar Documentos Avulsos' : 'Gerar Documentos' }}
            </h1>
            <p class="text-sm text-westetics-neutral-600 mt-1">
                Selecione os documentos que deseja preencher
            </p>
        </div>
        <div class="flex gap-3">
            <button 
                (click)="onBackToPatient()"
                class="px-4 py-2 text-sm font-medium rounded-lg transition-colors text-westetics-purple-800 hover:text-white border-westetics-purple-800 hover:bg-westetics-purple-800 border"
            >
            Cancelar
            </button>
            <button 
                (click)="onSubmit()"
                [disabled]="selectedFiles.length < 1"
                class="px-4 py-2 text-sm font-medium rounded-lg transition-colors"
                [ngClass]="{
                    'bg-westetics-purple-800 text-white hover:bg-westetics-purple-600': selectedFiles.length >= 1,
                    'bg-gray-300 text-gray-500 cursor-not-allowed': selectedFiles.length < 1
                }"
            >
                Avançar
            </button>
        </div>
    </div>

    <!-- INFORMAÇÕES DO PACIENTE -->
    <div class="bg-white rounded-lg border border-gray-200 p-4 mb-6 max-w-3xl">
        <div class="flex items-center gap-3">
            <div class="w-10 h-10 rounded-full bg-westetics-purple-100 flex items-center justify-center">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 4C13.0609 4 14.0783 4.42143 14.8284 5.17157C15.5786 5.92172 16 6.93913 16 8C16 9.06087 15.5786 10.0783 14.8284 10.8284C14.0783 11.5786 13.0609 12 12 12C10.9391 12 9.92172 11.5786 9.17157 10.8284C8.42143 10.0783 8 9.06087 8 8C8 6.93913 8.42143 5.92172 9.17157 5.17157C9.92172 4.42143 10.9391 4 12 4ZM12 14C16.42 14 20 15.79 20 18V20H4V18C4 15.79 7.58 14 12 14Z" fill="#6B21A8"/>
                </svg>
            </div>
            <div>
                <p class="text-sm font-medium text-westetics-neutral-950" *ngIf="patientId">
                    {{ patientName || 'Paciente' }}
                </p>
                <p class="text-sm font-medium text-westetics-neutral-950" *ngIf="!patientId">
                    Paciente Convidado
                </p>
                <p class="text-xs text-westetics-neutral-600" *ngIf="patientEmail">
                    {{ patientEmail }}
                </p>
            </div>
        </div>
    </div>

    <!-- LISTA DE DOCUMENTOS -->
    <div class="bg-white rounded-lg border border-gray-200 p-6 max-w-3xl">
        <!-- Header da lista -->
        <div class="flex justify-between items-center mb-4">
            <div>
                <h3 class="text-base font-semibold text-westetics-neutral-950 flex items-center gap-2">
                    <fa-icon [icon]="faFileAlt" class="text-westetics-purple-600"></fa-icon>
                    Documentos Disponíveis
                </h3>
                <p class="text-sm text-gray-500 mt-1" *ngIf="files.length > 0">
                    {{ selectedFiles.length }} de {{ files.length }} documento(s) selecionado(s)
                </p>
            </div>
            <button 
                *ngIf="files.length > 0"
                (click)="selectAll()"
                class="text-sm font-medium text-westetics-purple-800 hover:text-westetics-purple-900 transition-colors"
            >
                {{ selectedFiles.length === files.length ? 'Desmarcar todos' : 'Selecionar todos' }}
            </button>
        </div>

        <!-- Mensagem quando não há documentos -->
        <div *ngIf="files.length === 0" class="text-sm text-gray-500">
            Nenhum documento disponível
        </div>

        <!-- Lista de documentos -->
        <ul *ngIf="files.length > 0" class="space-y-2">
            <li 
                *ngFor="let file of files"
                (click)="toggleFileSelection(file.id)"
                class="flex items-center justify-between p-3 rounded-lg border cursor-pointer transition-colors"
                [ngClass]="isSelected(file.id) ? 'bg-westetics-purple-50 border-westetics-purple-300' : 'bg-white border-gray-200 hover:bg-gray-50'"
            >
                <div class="flex items-center gap-3 min-w-0">
                    <!-- Ícone do documento -->
                    <div 
                        class="w-8 h-8 min-w-[2rem] flex-shrink-0 flex items-center justify-center rounded-lg"
                        [ngClass]="isSelected(file.id) ? 'bg-westetics-purple-600' : 'bg-gray-100'"
                    >
                        <fa-icon 
                            [icon]="isSelected(file.id) ? faCheck : faFileAlt" 
                            [ngClass]="isSelected(file.id) ? 'text-white' : 'text-gray-500'"
                            class="text-sm"
                        ></fa-icon>
                    </div>
                    <!-- Nome do documento -->
                    <span class="text-sm font-medium" [ngClass]="isSelected(file.id) ? 'text-westetics-purple-800' : 'text-gray-800'">
                        {{ file.name }}
                    </span>
                </div>
                
                <!-- Checkbox -->
                <div *ngIf="isSelected(file.id)" class="text-westetics-purple-600 flex-shrink-0">
                    <fa-icon [icon]="faCheck"></fa-icon>
                </div>
            </li>
        </ul>
    </div>

    <!-- Botão de ação fixo em mobile -->
    <div class="sm:hidden fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-gray-200 fixed-bottom-safe">
        <button 
            (click)="onSubmit()"
            [disabled]="selectedFiles.length < 1"
            class="w-full px-4 py-3 text-sm font-medium rounded-lg transition-colors"
            [ngClass]="{
                'bg-westetics-purple-800 text-white hover:bg-westetics-purple-600': selectedFiles.length >= 1,
                'bg-gray-300 text-gray-500 cursor-not-allowed': selectedFiles.length < 1
            }"
        >
            Avançar ({{ selectedFiles.length }} selecionado{{ selectedFiles.length !== 1 ? 's' : '' }})
        </button>
    </div>

</div>
</ng-container>
